module.exports = __webpack_public_path__ + "img/options-impressionist.b55361ee.png";